import { getToken, modifyZoneList } from "../../helper/common";
import trimmedValues from "../../helper/trimmer";
import { clearForm, clearZoneForm } from "../form/actions";
import agent from "../services/agent";
import { showSnackbarStatus } from "../snackbar/actions";
import {
  CLOSE_CREATE_ZONE_MODAL,
  CLOSE_UPDATE_ZONE_MODAL,
  CREATE_ZONE_ERROR,
  CREATE_ZONE_PENDING,
  CREATE_ZONE_SUCCESS,
  GET_ZONES_PENDING,
  OPEN_CREATE_ZONE_MODAL,
  OPEN_UPDATE_ZONE_MODAL,
  SET_ZONES_LIST,
  UPDATE_ZONE_ERROR,
  UPDATE_ZONE_PENDING,
  UPDATE_ZONE_SUCCESS,
  CLEAR_ZONE_ERROR,
  SET_ZONE_DETAILS,
  SET_ASSIGNABLE_ZONES_LIST_ASYNC,
  ADD_ZONE,
  ZONE_LIST_ERROR,
  CLEAR_UPDATE_ZONE_ERROR,
} from "../zones/actionTypes";
// import { showSnackbarStatus } from "./snackbar.actions";

export const createZonePending = () => ({
  type: CREATE_ZONE_PENDING,
});

export const createZoneSuccess = () => ({
  type: CREATE_ZONE_SUCCESS,
});

export const createZoneError = (errorMessage) => ({
  type: CREATE_ZONE_ERROR,
  payload: { errorMessage },
});

export const updateZonePending = () => ({
  type: UPDATE_ZONE_PENDING,
});

export const updateZoneSuccess = () => ({
  type: UPDATE_ZONE_SUCCESS,
});

export const updateZoneError = (errorMessage) => ({
  type: UPDATE_ZONE_ERROR,
  payload: { errorMessage },
});

export const zoneListError = (errorMessage) => ({
  type: ZONE_LIST_ERROR,
  payload: { errorMessage },
});

export const clearZoneError = () => ({
  type: CLEAR_ZONE_ERROR,
});
export const clearUpdateZoneError = () => ({
  type: CLEAR_UPDATE_ZONE_ERROR,
});

export const openCreateZoneModal = () => ({
  type: OPEN_CREATE_ZONE_MODAL,
});

export const closeCreateZoneModal = () => ({
  type: CLOSE_CREATE_ZONE_MODAL,
});

export const openUpdateZoneModal = () => ({
  type: OPEN_UPDATE_ZONE_MODAL,
});

export const closeUpdateZoneModal = () => ({
  type: CLOSE_UPDATE_ZONE_MODAL,
});

export const getZonesPending = () => ({
  type: GET_ZONES_PENDING,
});

const setZonesList = (zonesOdata) => ({
  type: SET_ZONES_LIST,
  payload: { zonesOdata },
});

const setAssignableZonesListForAsyncSelect = (zonesList, searchValue) => ({
  type: SET_ASSIGNABLE_ZONES_LIST_ASYNC,
  payload: { zonesListAsync: zonesList, searchValueAsync: searchValue },
});

export const addZone = (AddZoneForm) => ({
  type: ADD_ZONE,
  payload: { AddZoneForm },
});

export const setZoneDetails = (zoneDetails) => ({
  type: SET_ZONE_DETAILS,
  payload: { zoneDetails },
});

export const getZonesList = (page, pageSize, sortDirection, sortOrder) => (dispatch) => {
  dispatch(getZonesPending());
  getToken(dispatch).then((accessToken) => {
    agent.Zone.getZoneData(accessToken, page, pageSize, sortDirection, sortOrder)
      .then((zoneList) => {
        dispatch(setZonesList(zoneList));
      })
      .catch((err) => {
        console.log("getZonesList server error", err);
        if (err && err.response) {
          const message = err.response.body.message ? err.response.body.message : err.response.body.error.message;
          dispatch(zoneListError(message));
          return;
        }
        else {
          const message = "Network error";
          dispatch(zoneListError(message));
        }
        dispatch(showSnackbarStatus("Something went wrong. Please try again later"));
      });
  });
};

export const createZone = (addZone) => (dispatch) => {
  const value = trimmedValues(addZone)
  dispatch(createZonePending());
  getToken(dispatch).then((accessToken) => {
    agent.Zone.create(accessToken, value)
      .then(() => {
        dispatch(clearZoneError());
        dispatch(createZoneSuccess());
        dispatch(clearZoneForm());
        dispatch(closeCreateZoneModal());
        dispatch(getZonesList());
        dispatch(showSnackbarStatus("Zone created successfully"));
      })
      .catch((err) => {
        if (err && err.response) {
          const message = err.response.body.message ? err.response.body.message : err.response.body.error.message;
          dispatch(createZoneError(message));
          return;
        }
        else {
          const message = "Network error";
          dispatch(createZoneError(message));
        }
        console.log("createZone server error", err);
        // dispatch(clearForm());
        // dispatch(createZoneError(null));
        // dispatch(closeCreateZoneModal());
        dispatch(showSnackbarStatus("Something went wrong. Please try again later"));
      });
  });
};

export const updateZone = (data) => (dispatch) => {
  const value = trimmedValues(data)
  dispatch(updateZonePending());
  getToken(dispatch).then((accessToken) => {
    agent.Zone.update(accessToken, value)
      .then(() => {
        dispatch(clearZoneError());
        dispatch(updateZoneSuccess());
        dispatch(clearForm());
        dispatch(closeUpdateZoneModal());
        dispatch(getZonesList());
        dispatch(showSnackbarStatus("Zone updated successfully"));
      })
      .catch((err) => {
        if (err && err.response) {
          const message = err.response.body.message ? err.response.body.message : err.response.body.error.message;
          dispatch(updateZoneError(message));
          return;
        }
        else {
          const message = "Network error";
          dispatch(updateZoneError(message));
        }
        console.log("updateZone server error", err);
        // dispatch(clearForm());
        // dispatch(updateZoneError(null));
        // dispatch(closeUpdateZoneModal());
        dispatch(showSnackbarStatus("Something went wrong. Please try again later"));
      });
  });
};

export const getAssignableZonesForAsyncSelect = (searchValue, callback) => (dispatch) => {
  getToken(dispatch).then((accessToken) => {
    agent.Zone.getAssignableZones(accessToken, searchValue)
      .then((zoneList) => {
        let zonesListOptions = modifyZoneList(zoneList);
        dispatch(setAssignableZonesListForAsyncSelect(zonesListOptions));
        callback && callback(zonesListOptions);
      })
      .catch((err) => {
        console.log("getAssignableZonesForAsyncSelect for dropdown server error", err);
        dispatch(showSnackbarStatus("Something went wrong. Please try again later"));
        callback && callback();
      });
  });
};
